import { render } from "./State.vue?vue&type=template&id=f12fc612"
import script from "./State.vue?vue&type=script&lang=js"
export * from "./State.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__